module.exports = __webpack_public_path__ + "6add222c28fa74d4f05de667ea3780fc.pdf";